<ng-template #shareTextOverlayFormRef>
  <div class="container">
    <div class="overlay-content">
      <h3>{{ header }}</h3>
      <div class="toggle-container form-item">
        <mat-slide-toggle
          [(ngModel)]="linkType"
          (change)="onToggleChange($event)"
          name="linkTypeToggle">
          External Link (30 min)
        </mat-slide-toggle>
      </div>
      <div class="input-container-box form-item">
        <textarea [(ngModel)]="!linkType ? shareText : temporaryLink" readonly></textarea>
      </div>
      <div class="row-buttons">
        <button class="btn btn-submit" (click)="copyToClipboard(!linkType ? shareText : temporaryLink)">
          Copy Link
        </button>
        <button class="btn btn-cancel" (click)="cancel()">Close</button>
      </div>
    </div>
  </div>
</ng-template>
